import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { BrandingProvider } from './context/BrandingContext';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ClientDashboard from './pages/ClientDashboard';
import CameraManagement from './pages/CameraManagement';
import ClientManagement from './pages/ClientManagement';
import Reports from './pages/Reports';
import AdminSettings from './pages/AdminSettings';
import ClientSettings from './pages/ClientSettings';
import ClientUsers from './pages/ClientUsers';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Alerts from './pages/Alerts';
import Holidays from './pages/Holidays';
import Goals from './pages/Goals';
import Comparison from './pages/Comparison';
import CameraMap from './pages/CameraMap';
import ActivityLog from './pages/ActivityLog';
import TwoFactor from './pages/TwoFactor';
import './index.css';

function ProtectedLayout({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
      <span className="loading-spinner" />
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} />;
  return (
    <div className="layout">
      <Sidebar />
      <main className="main-content">{children}</main>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Admin routai */}
      <Route path="/admin"            element={<ProtectedLayout role="admin"><AdminDashboard /></ProtectedLayout>} />
      <Route path="/admin/cameras"    element={<ProtectedLayout role="admin"><CameraManagement /></ProtectedLayout>} />
      <Route path="/admin/clients"    element={<ProtectedLayout role="admin"><ClientManagement /></ProtectedLayout>} />
      <Route path="/admin/settings"   element={<ProtectedLayout role="admin"><AdminSettings /></ProtectedLayout>} />
      <Route path="/admin/reports"    element={<ProtectedLayout role="admin"><Reports isAdmin={true} /></ProtectedLayout>} />
      <Route path="/admin/map"        element={<ProtectedLayout role="admin"><CameraMap /></ProtectedLayout>} />
      <Route path="/admin/comparison" element={<ProtectedLayout role="admin"><Comparison /></ProtectedLayout>} />
      <Route path="/admin/logs"       element={<ProtectedLayout role="admin"><ActivityLog /></ProtectedLayout>} />

      {/* Kliento routai */}
      <Route path="/dashboard"                element={<ProtectedLayout role="client"><ClientDashboard /></ProtectedLayout>} />
      <Route path="/dashboard/reports"        element={<ProtectedLayout role="client"><Reports isAdmin={false} /></ProtectedLayout>} />
      <Route path="/dashboard/users"          element={<ProtectedLayout role="client"><ClientUsers /></ProtectedLayout>} />
      <Route path="/dashboard/settings"       element={<ProtectedLayout role="client"><ClientSettings /></ProtectedLayout>} />
      <Route path="/dashboard/alerts"         element={<ProtectedLayout role="client"><Alerts /></ProtectedLayout>} />
      <Route path="/dashboard/holidays"       element={<ProtectedLayout role="client"><Holidays /></ProtectedLayout>} />
      <Route path="/dashboard/goals"          element={<ProtectedLayout role="client"><Goals /></ProtectedLayout>} />
      <Route path="/dashboard/comparison"     element={<ProtectedLayout role="client"><Comparison /></ProtectedLayout>} />
      <Route path="/dashboard/map"            element={<ProtectedLayout role="client"><CameraMap /></ProtectedLayout>} />
      <Route path="/dashboard/2fa"            element={<ProtectedLayout role="client"><TwoFactor /></ProtectedLayout>} />

      <Route path="/" element={<Navigate to={user ? (user.role === 'admin' ? '/admin' : '/dashboard') : '/login'} />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrandingProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ style: { background:'var(--card)', color:'var(--text)', border:'1px solid var(--border)' } }} />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </BrandingProvider>
  );
}
